/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-28 15:40:40
 * @Explain: 下拉分组
 */
import { ReactNode, useMemo, useState } from 'react';
import { PopupProps, Select, SelectProps } from 'tdesign-react';
import { InputSizeEnum, InputSizeType, SelectItemType } from '../data.d';
import classNames from 'classnames';
import SearchBox from '../searchBox';
import { doesItExist, isArrayLen } from '@/utils/common/dataJudgment';
import { intlGet } from '@/locales';

type SelectGroupItemType = {
  groupName: string;
  options: SelectItemType[];
};
type PropsType = {
  className?: string;
  list: SelectGroupItemType[];
  value?: SelectProps['value'];
  disabled?: boolean;
  placeholder?: string;
  size?: InputSizeType;
  footer?: SelectProps['panelBottomContent'];
  popupProps?: PopupProps;
  /** 自定义渲染选项 */
  customOption?: (item: SelectItemType) => ReactNode | string;
  onChange?: (val: any, { option }: { option: any }) => void;
};

function SelectGroup(props: PropsType) {
  const {
    className,
    list,
    value,
    disabled,
    placeholder,
    size,
    footer,
    popupProps,
    customOption,
    onChange,
  } = props;

  // 搜索
  const [searchValue, setSearchValue] = useState('');

  // 是否没有搜索到内容
  const isEmpty = useMemo(() => {
    let newList: SelectItemType[] = [];
    list.forEach((item) => {
      const newOptions = searchValue
        ? item.options.filter((item) => doesItExist(searchValue, item.label))
        : item.options;

      newList = newList.concat(newOptions);
    });

    return isArrayLen(newList) === 0;
  }, [list, searchValue]);

  return '暂时不用';
}

export default SelectGroup;
